import { render, staticRenderFns } from "./BrowseDataDatatable.vue?vue&type=template&id=c7353240"
import script from "./BrowseDataDatatable.vue?vue&type=script&lang=js"
export * from "./BrowseDataDatatable.vue?vue&type=script&lang=js"
import style0 from "./BrowseDataDatatable.vue?vue&type=style&index=0&id=c7353240&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports